'use strict';

angular.module('controllers')
	.directive('expandCollapseCard', function() {
		return {
			restrict: 'EA',
			link: function(scope, element, attrs){
				var el = angular.element(element[0].querySelector('#collapse-card'));
				el.bind('click', function (event) {
					angular.element(element[0].querySelector('md-card-content')).slideToggle('200',function() {
						angular.element(el[0].querySelector('i')).toggleClass('fa-plus fa-minus');

						angular.element(element[0].querySelector('.regular')).toggleClass('show hide');
						angular.element(element[0].querySelector('.alternative')).toggleClass('hide show');

						//element.css('width', '40%');
						//element.css('height', 'auto');

						//#send-order .wrap-card
						if (angular.element(el[0].querySelector('i')).hasClass('fa-minus')) {
							angular.element(element[0].querySelector('#send-order .wrap-card')).css('min-height', '650px');
						}
						if (angular.element(el[0].querySelector('i')).hasClass('fa-plus')) {
							angular.element(element[0].querySelector('#send-order .wrap-card')).css('min-height', '0');
						}
					});
					angular.element(element[0].querySelector('.cadre-bl')).toggleClass('hide show');
					angular.element(element[0].querySelector('.cadre-tr')).toggleClass('hide show');
				});

			/*	var elMinify = angular.element(element[0].querySelector('#minify-card'));
				elMinify.bind('click', function (event) {
					angular.element(element[0].querySelector('.see-image')).slideToggle('200');
				});*/

			}
		}

	});